import { render, staticRenderFns } from "./DSMValidation.vue?vue&type=template&id=ef25635a&scoped=true"
import script from "./DSMValidation.vue?vue&type=script&lang=js"
export * from "./DSMValidation.vue?vue&type=script&lang=js"
import style0 from "./DSMValidation.vue?vue&type=style&index=0&id=ef25635a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25635a",
  null
  
)

export default component.exports